import React from "react";
import { BiMinus, BiPlus } from "react-icons/bi";

function FAQ() {
  return (
    <div className="relative h-[calc(100vh+100px)] overflow-hidden">
      <div className="absolute top-48 left-36 bg-[#3B2E09] w-[248px] h-[688.552px] rotate-[39.237deg] rounded-[50%] blur-[150px]" />
      <div className="absolute top-2 right-52 bg-[#2C4146] w-[248px] h-[688.552px] rotate-[39.237deg] rounded-[50%] blur-[150px]" />
      <div className="flex items-center justify-center h-full max-w-6xl mx-auto">
        <div className="flex items-start justify-between w-full">
          <div className="flex flex-col items-start justify-start max-w-[250px] z-20">
            <h1 className="text-[26px] font-medium text-[#EAEAEA] mb-5">
              FAQs
            </h1>
            <p className="font-medium leading-snug text-nav">
              Everything you need to know about the product and billing. Can’t
              find the answer you’re looking for? Please chat to our friendly
              team.
            </p>
          </div>
          <div className="z-20 flex flex-col items-center w-full max-w-2xl">
            <div className="flex flex-col items-start justify-start w-full mb-10">
              <div className="flex items-center justify-between w-full mb-5">
                <h2 className="font-medium font-Gilroy text-[#E9E9E9]">
                  How secure is your software ?
                </h2>
                <div className="p-2 border rounded-full border-[#7F7F7F] text-[#E9E9E9]">
                  <BiMinus size={10} />
                </div>
              </div>

              <p className="font-medium leading-snug pr-28 text-nav">
                Security is our top priority. We use industry-standard
                encryption, secure coding practices, and regular vulnerability
                testing to ensure your data is protected.
              </p>
            </div>

            <div className="flex items-center justify-between w-full mb-10">
              <h2 className="font-medium font-Gilroy text-[#E9E9E9]">
                Can your software integrate with our existing systems?
              </h2>
              <div className="p-2 border rounded-full border-[#7F7F7F] text-[#E9E9E9]">
                <BiPlus size={10} />
              </div>
            </div>

            <div className="flex items-center justify-between w-full mb-10">
              <h2 className="font-medium font-Gilroy text-[#E9E9E9]">
                What services does your company provide?
              </h2>
              <div className="p-2 border rounded-full border-[#7F7F7F] text-[#E9E9E9]">
                <BiPlus size={10} />
              </div>
            </div>

            <div className="flex items-center justify-between w-full mb-10">
              <h2 className="font-medium font-Gilroy text-[#E9E9E9]">
                Do your softwares support multiple languages?
              </h2>
              <div className="p-2 border rounded-full border-[#7F7F7F] text-[#E9E9E9]">
                <BiPlus size={10} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
